// Lichtgewicht, cookieloze analytics naar de Ad-Deen-worker.
// Stuurt alleen op productie-hosts; faalt stil zodat de site nooit hindert.
const ENDPOINT = 'https://addeen.anass-basraoui.workers.dev/api/track';
const SITE = 'juzamma';

function enabled() {
  if (typeof window === 'undefined') return false;
  return /(^|\.)juzamma\.nl$|\.pages\.dev$/.test(window.location.hostname);
}

export function track(type, { label, value } = {}) {
  if (!enabled()) return;
  try {
    fetch(ENDPOINT, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        site: SITE,
        type,
        path: window.location.pathname,
        label,
        value,
        ref: document.referrer || undefined,
      }),
    }).catch(() => {});
  } catch { /* nooit de site laten struikelen over analytics */ }
}

export const trackPageview = () => track('pageview');
